var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemPicker',{staticClass:"masonry",attrs:{"items":_vm.availableMixtures},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return _c('div',{staticClass:"masonry-item"},[_c('MixtureTile',{staticClass:"tile",attrs:{"mixture":item},nativeOn:{"click":function($event){return _vm.$emit('input', item.components)}}})],1)}}])})}
var staticRenderFns = []

export { render, staticRenderFns }